module.exports = __webpack_public_path__ + "img/home-1.a4c0dd5b.png";